import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {ServiceAreaRequests} from "../../../service-areas/services/service-area-requests.service";

export class BringozServiceAreaSingleSelectDirective implements IController {
  selectedServiceAreas: any;
  selectedServiceAreaIds: any;
  branchIds: any;
  optionIds: any;
  noUnderline: any;
  ngPlaceholder: any;
  onChange: Function;

  serviceAreasRef: any;
  serviceAreaList: any[] = [];
  loaded: boolean = false;
  searchTerm: string = '';


  constructor(private $mdSelect, private $serviceArea, private $log, private $q: IQService, private serviceAreaRequests: ServiceAreaRequests) {
  }

  $onInit() {
    this.serviceAreasRef = this.$serviceArea();
    if (!this.selectedServiceAreas) {
      this.selectedServiceAreas = [];
    }

    if (this.selectedServiceAreaIds && this.selectedServiceAreaIds.length) {
      this.serviceAreasRef.$asyncValues(_.compact(this.selectedServiceAreaIds))
        .then((serviceAreas) => {
          this.serviceAreaList = !this.serviceAreaList.length ?
            _.orderBy(serviceAreas, ['areaName'], ['asc']) :
            _.orderBy(this.serviceAreaList, ['areaName'], ['asc']);
          this.selectedServiceAreas = serviceAreas;
        })
    } else if (this.selectedServiceAreas && this.selectedServiceAreas.length) {
      this.serviceAreaList = _.orderBy(this.selectedServiceAreas, ['areaName'], ['asc']);
    } else {
      this.serviceAreaList = [];
      this.selectedServiceAreas = [];
      this.loaded = false;
    }
  }

  $onChanges(changes) {
    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      this.serviceAreaList = [];
      this.loaded = false;
    }
    if (changes.selectedServiceAreaIds && !changes.selectedServiceAreaIds.isFirstChange()) {
      this.$onInit();
    }
  }

  onOpen() {
    if (!this.loaded) {

      if (this.optionIds) {
        return this.getServiceAreasByIds(this.optionIds)
          .then((serviceAreas) => {
            this.initServiceAreas(serviceAreas);
          })
      } else if (this.branchIds && this.branchIds.length && !_.isUndefined(this.branchIds[0])) {
        return this.getServiceAreasFromBranches(this.branchIds)
          .then((serviceAreas) => {
            this.initServiceAreas(serviceAreas);
          });
      } else {
        return this.getServiceAreasFromSite()
          .then((serviceAreas) => {
            this.initServiceAreas(serviceAreas);
          })
      }
    } else {
      return this.$q.when();
    }
  }

  cancel() {
    this.$mdSelect.hide();
  }

  select() {
    this.searchTerm = '';
    this.$mdSelect.hide();
  }

  reset() {
    this.selectedServiceAreas = [];
    this.searchTerm = '';
    this.$mdSelect.hide();
  }

  private getServiceAreasByIds(areaIds) {
    return this.serviceAreasRef.$asyncValues(areaIds);
  }

  private getServiceAreasFromBranches(branchIds) {
    return this.serviceAreaRequests.getAll({branchIds: branchIds});
  }

  private getServiceAreasFromSite() {
    return this.serviceAreasRef.$getAll()
      .then((areaIds) => {
        return this.getServiceAreasByIds(areaIds)
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get service areas ' +
            'DeliveriesViewCtrl \n' + error);
        }
      });
  }

  private initServiceAreas(serviceAreas) {
    this.serviceAreaList = _.orderBy(serviceAreas, ['areaName'], ['asc']);
    if (this.selectedServiceAreaIds) {

      if (!_.isArray(this.selectedServiceAreaIds)) {
        this.selectedServiceAreaIds = [this.selectedServiceAreaIds];
      }
      this.selectedServiceAreas = _.filter(serviceAreas, (area) => {
        return _.indexOf(this.selectedServiceAreaIds, area.areaId) !== -1
      });
    }
    this.loaded = true;
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozServiceAreaSingleSelect', {
    bindings: {
      selectedServiceAreas: '<?',
      selectedServiceAreaIds: '<?',
      branchIds: '<?',
      optionIds: '<?',
      noUnderline: '@?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-service-area-single-select/bringoz-service-area-single-select.tmpl.html',
    controller: BringozServiceAreaSingleSelectDirective
  });
